module.exports = __webpack_public_path__ + "static/img/delong1.e5f64fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/delong1.jpg
// module id = BtW4
// module chunks = 0